/**
 * How a person is named in a list.
 *
 * Every legal name part is optional, so the composed legal name is legitimately
 * empty for somebody recorded under a preferred name only — and a row with nothing
 * in its name column is unusable in a list whose whole job is finding a person.
 *
 * One implementation because a person must read the same wherever they are listed.
 * The People list and an organization's roster both show the same people, and the
 * second one exists so a headcount can be checked against the first; two copies of
 * this fallback would eventually disagree, and the disagreement would look like two
 * different people.
 *
 * The dash is the last resort and means "no name recorded at all", which is a record
 * somebody needs to go and fix rather than something to hide.
 */
export function personDisplayName(person: {
  legalFullName: string;
  preferredFullName: string;
}): string {
  return person.legalFullName || person.preferredFullName || "—";
}
